export const dataItemsAdmin = [
  {
    name: 'Dashboard',
    link: '/dashboard',
    logo: 'uil-home-alt me-2',
  },
  {
    name: 'Admins',
    link: '/admin-management',
    logo: 'uil-user-circle me-2',
  },

  // {
  //   name: 'Tokenization',
  //   logo: 'uil-chart-growth me-2',
  //   nestedtab: [
  //     {
  //       name: 'Investment Pool',
  //       link: '/investment-pool',
  //       logo: 'uil uil-chart-pie font-size-18 align-middle me-2 text-muted',
  //     },
  //   ],
  // },
  {
    name: 'Users',
    logo: 'uil-user me-2',
    nestedtab: [
      {
        name: 'Investor Management',
        link: '/investor-management',
        logo: 'uil-user me-2',
      },
      {
        name: 'Issuer Management',
        link: '/issuer-management',
        logo: 'uil-user-square me-2',
      },
      {
        name: 'Agents Management',
        link: '/agent-verification',
        logo: 'uil-users-alt me-2',
      },

      {
        name: 'Property Managers',
        link: '/property-managers',
        logo: 'uil uil-building font-size-18 align-middle me-2 text-muted',
      },
    ],
  },
  {
    name: 'Properties',
    logo: 'uil-home me-2',
    nestedtab: [
      {
        name: 'Approval Requests',
        link: '/draft-properties',
        logo: 'uil uil-clipboard-alt font-size-18 align-middle me-2 text-muted',
      },
      {
        name: ' Approved Properties',
        link: '/approved-properties',
        logo: 'uil uil-building font-size-18 align-middle me-2 text-muted',
      },
      {
        name: ' Subscribed Properties',
        link: '/subscribed-properties',
        logo: 'uil uil-building font-size-18 align-middle me-2 text-muted',
      },
      {
        name: ' Purchased Properties',
        link: '/purchased-properties',
        logo: 'uil uil-building font-size-18 align-middle me-2 text-muted',
      },
      {
        name: ' Rejected Properties',
        link: '/rejected-properties',
        logo: 'uil uil-times font-size-18 align-middle me-2 text-muted',
      },
      {
        name: ' Cancelled Properties',
        link: '/cancelled-properties',
        logo: 'uil uil-ban font-size-18 align-middle me-2 text-muted',
      },
    ],
  },
  {
    name: 'Management Master',
    logo: 'uil-setting me-2',
    nestedtab: [
      {
        name: 'Fee Master',
        link: '/management-master/fee-master',
        logo: 'uil uil-percentage font-size-18 align-middle me-2 text-muted',
      },
      {
        name: 'Payment Configuration',
        link: '/management-master/payment-configuration',
        logo: 'uil uil-money-withdrawal font-size-18 align-middle me-2 text-muted',
      },
      {
        name: 'Notification Settings',
        link: '/management-master/notification-settings',
        logo: 'uil uil-bell font-size-18 align-middle me-2 text-muted',
      },
    ],
  },
  {
    name: 'Cashflow',
    link: '/cashflow',
    logo: 'uil-money-bill me-2',
  },
];

export const dataItems = [
  {
    name: 'Dashboard',
    link: '/dashboard',
    logo: 'uil-home-alt me-2',
  },
  {
    name: 'Admins',
    link: '/admin-management',
    logo: 'uil-user-circle me-2',
  },
  // {
  //   name: 'Tokenization',
  //   logo: 'uil-chart-growth me-2',
  //   nestedtab: [
  //     {
  //       name: 'Investment Pool',
  //       link: '/investment-pool',
  //       logo: 'uil uil-chart-pie font-size-18 align-middle me-2 text-muted',
  //     },
  //   ],
  // },
  {
    name: 'Users',
    logo: 'uil-user me-2',
    nestedtab: [
      {
        name: 'Investor Management',
        link: '/investor-management',
        logo: 'uil-user me-2',
      },
      {
        name: 'Issuer Management',
        link: '/issuer-management',
        logo: 'uil-user-square me-2',
      },
      {
        name: 'Agents Management',
        link: '/agent-verification',
        logo: 'uil-users-alt me-2',
      },

      {
        name: 'Property Managers',
        link: '/property-managers',
        logo: 'uil uil-building font-size-18 align-middle me-2 text-muted',
      },
    ],
  },
  {
    name: 'Properties',
    logo: 'uil-home me-2',
    nestedtab: [
      {
        name: 'Approval Requests',
        link: '/draft-properties',
        logo: 'uil uil-clipboard-alt font-size-18 align-middle me-2 text-muted',
      },
      {
        name: ' Approved Properties',
        link: '/approved-properties',
        logo: 'uil uil-building font-size-18 align-middle me-2 text-muted',
      },
      {
        name: ' Subscribed Properties',
        link: '/subscribed-properties',
        logo: 'uil uil-building font-size-18 align-middle me-2 text-muted',
      },
      {
        name: ' Purchased Properties',
        link: '/purchased-properties',
        logo: 'uil uil-building font-size-18 align-middle me-2 text-muted',
      },
      {
        name: ' Rejected Properties',
        link: '/rejected-properties',
        logo: 'uil uil-times font-size-18 align-middle me-2 text-muted',
      },
      {
        name: ' Cancelled Properties',
        link: '/cancelled-properties',
        logo: 'uil uil-ban font-size-18 align-middle me-2 text-muted',
      },
    ],
  },
  {
    name: 'Cashflow',
    link: '/cashflow',
    logo: 'uil-money-bill me-2',
  },
];
